module.exports = __webpack_public_path__ + "static/media/PalletTrader Plus_logoC.4901c716.jpg";